export const BREAKPOINTS = {
  smallMobile: 400,
  mobile: 992,
  tablet: 1200,
  navigation: 1350,
  variants: {
    mobile: "mobile",
    desktop: "desktop",
  },
};